import React from 'react';
import './App.css';
import { Bars } from 'react-loader-spinner'

const Loading = () => {
  return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh'}}><Bars height="80" width="80" color="#4fa94d" ariaLabel="bars-loading" wrapperStyle={{}} wrapperClass="" visible={true} /></div>
}

export default Loading;
